// import store from '@/store';
import { io } from 'socket.io-client';

let socket = null;

// eslint-disable-next-line consistent-return
const conectar = (empresasSelecionadas) => {
  if (empresasSelecionadas) {
    return io(process.env.VUE_APP_WEBSOCKET, {
      path: '/ws',
      transports: ['websocket'],
      auth: {
        token: localStorage.getItem('token:@CTRL'),
      },
      headers: {
        'x-empresas-selecionadas': empresasSelecionadas,
      },
    });
  }
};

const getSocket = (empresasSelecionadas) => {
  if (!socket?.connected) {
    socket = conectar(empresasSelecionadas);
  }
  return socket;
};

const disconnectSocket = () => {
  if (socket?.connected) {
    socket.disconnect();
  }
};

export { disconnectSocket, getSocket };
